import React, { useState } from 'react';
import { Box, Flex, Image, Link as ChakraLink, IconButton, VStack, Button } from '@chakra-ui/react';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import { motion } from 'framer-motion';
import logo from '../../assets/images/logo1.png';

const MotionBox = motion(Box);

const MyNavbar: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const navLinks = [
    { title: "Servicios", url: "#servicios" },
    { title: "Trabajos", url: "#projects" },
    { title: "Quienes Somos", url: "#about-us" },

  ];

  const menuVariants = {
    open: { opacity: 1, y: 0, display: "flex", transition: { duration: 0.5 } },
    closed: { opacity: 0, y: "-100%", transitionEnd: { display: "none" }, transition: { duration: 0.5 } },
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  // Manejar el clic en el logo
  const handleLogoClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault(); // Evita la navegación por defecto

    // Si ya estamos en la página de inicio, forzamos la recarga
    if (location.pathname === '/') {
      window.location.reload();
    } else {
      // Navegamos a la página de inicio
      navigate('/');
    }
  };

  return (
    <Box as="nav" bg="white" width="100%" position="fixed" top={0} zIndex={1000} boxShadow="md">
      <Flex maxW="1800px" mx="auto" py={3} px={{ base: 4, md: 6 }} align="center" justify="space-between">
        {/* Enlace del logo - columna izquierda */}
        <Box flex={{ base: "0 0 auto", lg: "1" }} minW={{ base: "120px", md: "150px" }}>
          <ChakraLink as={RouterLink} to="/" onClick={handleLogoClick}>
            <Image src={logo} alt="TokenMeet Logo" height={{ base: "25px", md: "30px" }} objectFit="contain" />
          </ChakraLink>
        </Box>

        {/* Enlaces de navegación - columna central */}
        <Flex
          as="nav"
          display={{ base: "none", lg: "flex" }}
          align="center"
          justify="center"
          gap={6}
          flex="1"
        >
          {navLinks.map((link, index) => (
            <ChakraLink
              key={index}
              href={link.url}
              px={3}
              py={2}
              fontSize="sm"
              color="black"
              _hover={{ textDecoration: "underline" }}
              whiteSpace="nowrap"
            >
              {link.title}
            </ChakraLink>
          ))}
        </Flex>

        {/* Botón de contacto - columna derecha */}
        <Flex flex={{ base: "0 0 auto", lg: "1" }} justify="flex-end">
          <Button
            onClick={scrollToContact}
            display={{ base: "none", lg: "block" }}
            bgGradient="linear(100deg, #0ef1fa, #2ba1ce)"
            color="white"
            borderRadius="full"
            size="md"
            _hover={{
              bgGradient: "linear(100deg, #2ba1ce, #0ef1fa)",
              transform: "scale(1.05)",
            }}
            transition="all 0.3s"
            fontWeight="bold"
          >
            Contacto
          </Button>

          <IconButton
            aria-label="Open menu"
            icon={isMobileMenuOpen ? <CloseIcon /> : <HamburgerIcon />}
            display={{ base: "block", lg: "none" }}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            size="sm"
          />
        </Flex>
      </Flex>

      <MotionBox
        position="fixed"
        top="64px"  // Ajustar para que esté justo debajo del navbar (ajusta según la altura del navbar)
        left={0}
        right={0}
        height="calc(100vh - 64px)"  // El resto de la pantalla después del navbar
        bg="white"
        zIndex={999}
        initial="closed"
        animate={isMobileMenuOpen ? "open" : "closed"}
        variants={menuVariants}
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <VStack spacing={8}>
          {navLinks.map((link, index) => (
            <ChakraLink
              key={index}
              href={link.url}
              fontSize="2xl"
              color="black"
              onClick={() => setIsMobileMenuOpen(false)}
              _hover={{ textDecoration: "underline", color: "blue.500" }}
            >
              {link.title}
            </ChakraLink>
          ))}
          <Button
            onClick={scrollToContact}
            bgGradient="linear(100deg, #0ef1fa, #2ba1ce)"
            color="white"
            borderRadius="full"
            size="lg"
            _hover={{
              bgGradient: "linear(100deg, #2ba1ce, #0ef1fa)",
              transform: "scale(1.05)",
            }}
            transition="all 0.3s"
            fontWeight="bold"
          >
            Contacto
          </Button>
        </VStack>
      </MotionBox>
    </Box>
  );
};

export default MyNavbar;
